angular.module('qkr').directive('inverted', () => ({
        require: 'ngModel',
        link(scope, element, attrs, ngModel) {
            ngModel.$parsers.push((val) => !val);
            ngModel.$formatters.push((val) => !val);
        }
    }));



// WEBPACK FOOTER //
// ./src/directives/invert.js